/** @jsx jsx */

import { jsx } from '@emotion/core';
import useImageLoader from 'hooks/useImageLoader';
import { useCachedResource } from 'services/useCachedResource';
import { CHAMELEON_CACHE_v1 } from 'services/imageCache';

const Background = ({ backgroundImage, backgroundImageOpacity }) => {
  const backgroundImageURL = backgroundImage
    .split(/\(|\)/g)[1]
    .replace(/'/g, '');

  const cachedBackgroundImage = useCachedResource(
    CHAMELEON_CACHE_v1,
    backgroundImageURL
  );

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        background: `url('${cachedBackgroundImage ||
          backgroundImageURL}') center / cover no-repeat`,
        opacity: backgroundImageOpacity / 100,
      }}
    />
  );
};

export default Background;
